__turbopack_context__.v({
  "mobile-icon-tile": "mobile-icon-tile-component-module-scss-module__DD0j-W__mobile-icon-tile",
  "mobile-icon-tile--circled": "mobile-icon-tile-component-module-scss-module__DD0j-W__mobile-icon-tile--circled",
  "mobile-icon-tile__icon-text": "mobile-icon-tile-component-module-scss-module__DD0j-W__mobile-icon-tile__icon-text",
  "mobile-icon-tile__icon-wrapper": "mobile-icon-tile-component-module-scss-module__DD0j-W__mobile-icon-tile__icon-wrapper",
  "mobile-icon-tile__icon-wrapper--circled": "mobile-icon-tile-component-module-scss-module__DD0j-W__mobile-icon-tile__icon-wrapper--circled",
});
